// extracted by mini-css-extract-plugin
module.exports = {"root":"FaqsBlock_root__UX1Zk","title":"FaqsBlock_title__46nqo"};